/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import BackToTop from "./components/BackToTop";
import { setCookie, getCookie } from "./components/cookies";
import Links from "./components/Links";
import Sliders from "./components/Sliders";

document.addEventListener("DOMContentLoaded", () => {
	const burgerWrapper = document.querySelector(".burger-menu");
	const burgerLines = document.querySelector(".burger-js");
	const header = document.querySelector(".header");
	const menuItems = document.querySelectorAll(
		".burger-menu__menu-list > li.menu-item-has-children",
	);

	menuItems.forEach(function (item) {
		item.addEventListener("click", function (e) {
			if (e.target.closest(".mega-menu__back")) {
				return;
			}

			e.preventDefault();

			menuItems.forEach(function (el) {
				el.classList.remove("active");
			});

			item.classList.add("active");
		});

		const backButton = item.querySelector(".mega-menu__back");

		if (backButton) {
			backButton.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				item.classList.remove("active");
			});
		}
	});

	if (burgerLines) {
		burgerLines.addEventListener("click", function () {
			if (burgerWrapper) {
				if (burgerWrapper.classList.contains("active")) {
					burgerWrapper.classList.remove("active");
					burgerLines.classList.remove("open");
				} else {
					burgerWrapper.classList.add("active");
					burgerLines.classList.add("open");
				}
			}
		});
	}

	if (header) {
		const toggleFixed = () => {
			header.classList.toggle("fixed", window.scrollY > 0);
		};

		toggleFixed();
		window.addEventListener("scroll", toggleFixed);
	}


	const buttons = document.querySelectorAll(".single-product__switch-btn");

	if (buttons.length > 0) {
		buttons.forEach((btn) => {
			btn.addEventListener("click", function () {
				const type = this.dataset.type;

				buttons.forEach((b) => {
					b.classList.remove("active");
				});

				this.classList.add("active");

				const blocks = document.querySelectorAll(".single-product__content [data-type], .single-product__pro-description[data-type]");

				blocks.forEach((block) => {
					const blockType = block.dataset.type;
					let show = false;

					if (blockType === "both") {
						show = true;
					} else if (blockType === type) {
						show = true;
					}

					if (show) {
						block.style.display = "block";
					} else {
						block.style.display = "none";
					}

					const next = block.nextElementSibling;

					if (next && next.classList.contains("separator")) {
						if (show) {
							next.style.display = "block";
						} else {
							next.style.display = "none";
						}
					}
				});
			});
		});
	}


	Links();
	Sliders();
    BackToTop();
});

document.addEventListener("wpcf7mailsent", () => {
	window.location.assign(`${window.location.origin}/dziekujemy/`);
});
